import * as d3 from 'd3'

export default {
  methods: {

    draw_ChartCanvas(selection) {

      let canvasChart = selection
      .append('g')
      .attr('transform', `translate(0, 0)`)

      this.draw_ChartAxis(canvasChart) //-----> below
      this.draw_Grid(canvasChart) //-----> below
      this.draw_Legends(canvasChart) //-----> below
    },

    
    draw_ChartAxis(selection) {
      let axes = selection

      axes
      .append('line')
      .attr('x1', 0).attr('x2', 0).attr('y1', 0).attr('y2', this.chart.height)
      .attr('stroke', '#757575').attr('stroke-width', .5).attr('opacity', .5)

      axes
      .append('line')
      .attr('x1', 0).attr('x2', this.chart.width).attr('y1', this.chart.height).attr('y2', this.chart.height)
      .attr('stroke', '#757575').attr('stroke-width', .5).attr('opacity', .5)

      axes
      .append('line')
      .attr('x1', this.chart.width).attr('x2', this.chart.width).attr('y1', 0).attr('y2', this.chart.height)
      .attr('stroke', '#757575' ).attr('stroke-width', .5).attr('opacity', .5)

    },


    draw_Grid(selection) {
      let tick = this.chart.height / 4
      let grids = selection

      grids // Grid
      .append('line')
      .attr('x1', 0).attr('x2', this.chart.width)
      .attr('y1', this.chart.height/2).attr('y2', this.chart.height/2)
      .attr('stroke', '#757575').attr('stroke-width', .5)
      .attr('opacity', .5)

      for(let i=0; i<5; i++) {
        grids // Grid
        .append('line')
        .attr('x1', 0).attr('x2', this.chart.width)
        .attr('y1', tick * i).attr('y2', tick * i)
        .attr('stroke', '#bcbcbc').attr('stroke-width', .5)
        .attr('opacity', .5)

        if(i<3) {
          grids // Primary Axis
          .append('text')
          .attr('x', (this.primary.position == 'left') ? -2 : this.chart.width + 2)
          .attr('y', (this.chart.height/2) - (tick * i) + 8*0.26)  
          .attr('font-size', 8).attr('fill', '#757575')
          .attr('text-anchor', (this.primary.position == 'left') ? 'end': 'start')
          .text(()=> {
            let value = (this.primary.max * (i*.5)).toFixed(0)
            if(this.primary.unit.toLowerCase() == 'k') value = (value/1000).toFixed(1)
            return value
          })

          grids // secondary Axis
          .append('text')
          .attr('x', (this.secondary.position == 'left') ? -2 : this.chart.width + 2)
          .attr('y', (this.chart.height/2) - (tick * i) + 8*0.26)
          .attr('font-size', 8).attr('fill', '#757575')
          .attr('text-anchor', (this.secondary.position == 'left') ? 'end': 'start')
          .text( ()=> {
            let value = (this.secondary.max * (i*.5)).toFixed(0)
            if(this.secondary.unit.toLowerCase() == 'k') value = (value/1000).toFixed(1)
            return value
          })

        } else {

          let j = i - 3
          grids // Primary Axis
          .append('text')
          .attr('x', (this.primary.position == 'left') ? -2 : this.chart.width + 2)
          .attr('y', this.chart.height - (tick * j) + 8*0.26)  
          .attr('font-size', 8).attr('fill', '#757575')
          .attr('text-anchor', (this.primary.position == 'left') ? 'end': 'start')
          .text(()=> {
            let value = this.primary.max - (this.primary.max * (j*.5)).toFixed(0)
            if(this.primary.unit.toLowerCase() == 'k') value = (value/1000).toFixed(1)
            return value
          })

          grids // secondary Axis
          .append('text')
          .attr('x', (this.secondary.position == 'left') ? -2 : this.chart.width + 2)
          .attr('y', this.chart.height - (tick * j) + 8*0.26)
          .attr('font-size', 8).attr('fill', '#757575')
          .attr('text-anchor', (this.secondary.position == 'left') ? 'end': 'start')
          .text( ()=> {
            let value = this.secondary.max - (this.secondary.max * (j*.5)).toFixed(0)
            if(this.secondary.unit.toLowerCase() == 'k') value = (value/1000).toFixed(1)
            return value
          })
        }
      }
    },


    draw_Legends(selection) {

      let item = selection
      .append('g')
      .attr('id', `LEGEND_GROUP_${this.localId}`)
      .attr('transform', `translate(0, ${this.chart.height + 25})`)
      
      let x_ = 0
      this.chart.styles.forEach((d,i)=> {
        item
        .append('circle')
        .attr('id', `ICON_${i}_${this.localId}`)
        .attr('cx', x_).attr('cy', 3).attr('r', 4)
        .attr('fill', d.color)

        item
        .append('text')
        .attr('id', `LEGEND_${i}_${this.localId}`)
        .attr('transform', `translate(${x_ + 8}, ${4 + this.legends.tSize*0.26})`)
        .attr('font-size', this.legends.tSize).attr('fill', this.legends.tColor)
        .text(d.name)

        x_ = x_ + this.getNode(`#LEGEND_${i}_${this.localId}`, 'width') + 25
      })

      let len = this.getNode(`#LEGEND_GROUP_${this.localId}`, 'width')
      if(this.legends.align == 'center') {
        d3.select(`#LEGEND_GROUP_${this.localId}`)
        .attr('transform', `translate(${this.chart.x + (this.chart.width/2) - (len/2)}, ${this.legends.y})`)
      }
      if(this.legends.align == 'right') {
        d3.select(`#LEGEND_GROUP_${this.localId}`)
        .attr('transform', `translate(${this.chart.x + this.chart.width - len - 1}, ${this.legends.y})`)
      }
    },

  }
}